import { NotifyHelper } from "../../../helpers/toast";
import { eQuanLyHocPhanActionsObj } from "../../action-types/quyet-dinh/IQuanLyHocPhanActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const quanLyHocPhanActions = {
  ...generateActions(eQuanLyHocPhanActionsObj, "QUAN_LY_HOC_PHAN"),
  ...generateActionForKey(
    eQuanLyHocPhanActionsObj,
    "QUAN_LY_HOC_PHAN",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã cập nhật");
    }
  ),
  ...generateActionForKey(
    eQuanLyHocPhanActionsObj,
    "QUAN_LY_HOC_PHAN",
    "SAVE_ERRR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eQuanLyHocPhanActionsObj,
    "QUAN_LY_HOC_PHAN",
    "DELETE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    }
  ),
  ...generateActionForKey(
    eQuanLyHocPhanActionsObj,
    "QUAN_LY_HOC_PHAN",
    "DELETE_ERRR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
};
